import React, { useState, useEffect } from 'react';
import { io } from 'socket.io-client';

const WebSocketBadge = () => {
    const [isConnected, setIsConnected] = useState(false);

    useEffect(() => {
        const socketUrl = (process.env.REACT_APP_API_URL || 'http://localhost:8009/api').replace('/api', '');
        const socket = io(socketUrl);

        socket.on('connect', () => {
            setIsConnected(true);
        });

        socket.on('disconnect', () => {
            setIsConnected(false);
        });

        // Depending on backend implementation, it might trigger custom connected events too,
        // but the standard socket.io connect/disconnect will work for general availability.

        return () => {
            socket.disconnect();
        };
    }, []);

    const badgeStyle = {
        position: 'absolute',
        top: '1rem',
        right: '2rem',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '6px 16px',
        borderRadius: '9999px',
        fontWeight: '600',
        fontSize: '0.875rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        zIndex: 1000,
        backgroundColor: isConnected ? '#dcfce7' : '#fee2e2',
        color: isConnected ? '#166534' : '#991b1b',
        border: `1px solid ${isConnected ? '#bbf7d0' : '#fecaca'}`,
        transition: 'all 0.3s ease'
    };

    const dotStyle = {
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        backgroundColor: isConnected ? '#22c55e' : '#ef4444',
        boxShadow: `0 0 0 4px ${isConnected ? 'rgba(34, 197, 94, 0.2)' : 'rgba(239, 68, 68, 0.2)'}`
    };

    return (
        <div style={badgeStyle}>
            <div style={dotStyle}></div>
            {isConnected ? 'Connected' : 'Disconnected'}
        </div>
    );
};

export default WebSocketBadge;
